<h2 mat-dialog-title>Contract Details</h2>

<mat-dialog-content>
  <div class="info-container">

    <div class="info-section">
      <h3>Basic Information</h3>
      <div class="info-row">
        <span class="label">ID:</span>
        <span class="value copyable" (click)="copyToClipboard(data.contract.id)">
          <span class="text">{{ data.contract.id }}</span>
          <mat-icon>content_copy</mat-icon>
        </span>
      </div>
      <div class="info-row">
        <span class="label">Name:</span>
        <span class="value copyable" (click)="copyToClipboard(data.contract.name)">
          <span class="text">{{ data.contract.name || 'N/A' }}</span>
          <mat-icon>content_copy</mat-icon>
        </span>
      </div>
      <div class="info-row">
        <span class="label">Note:</span>
        <span class="value">{{ data.contract.note || 'N/A' }}</span>
      </div>
      <div class="info-row">
        <span class="label">Target Type:</span>
        <span class="value">{{ data.contract.target_type }}</span>
      </div>
    </div>

    @if (data.contract.buyer_account_info) {
    <div class="info-section">
      <h3>Buyer</h3>
      <div class="info-row">
        <span class="label">Name:</span>
        <span class="value copyable" (click)="copyToClipboard(data.contract.buyer_account_info.name)">
          <span class="text">{{ data.contract.buyer_account_info.name }}</span>
          <mat-icon>content_copy</mat-icon>
        </span>
      </div>
      <div class="info-row">
        <span class="label">Email:</span>
        <span class="value copyable" (click)="copyToClipboard(data.contract.buyer_account_info.email)">
          <span class="text">{{ data.contract.buyer_account_info.email }}</span>
          <mat-icon>content_copy</mat-icon>
        </span>
      </div>
      <div class="info-row">
        <span class="label">Login ID:</span>
        <span class="value copyable" (click)="copyToClipboard(data.contract.buyer_account_info.login_info_id)">
          <span class="text">{{ data.contract.buyer_account_info.login_info_id }}</span>
          <mat-icon>content_copy</mat-icon>
        </span>
      </div>
    </div>
    }

    <div class="info-section">
      <h3>Status</h3>
      <div class="info-row">
        <span class="label">Status:</span>
        <span class="value status-badge" [ngClass]="'status-' + data.contract.status.toLowerCase()">
          {{ data.contract.status }}
        </span>
      </div>
      <div class="info-row">
        <span class="label">Payment:</span>
        <span class="value payment-badge" [ngClass]="data.contract.payment_status === 'Payed' ? 'payed' : 'not-payed'">
          {{ data.contract.payment_status }}
        </span>
      </div>
      <div class="info-row">
        <span class="label">Archived:</span>
        <span class="value">{{ data.contract.archived ? 'Yes' : 'No' }}</span>
      </div>
      <div class="info-row">
        <span class="label">In Pool:</span>
        <span class="value in-pool-badge" [ngClass]="data.contract.in_pool ? 'in-pool-yes' : 'in-pool-no'">
          {{ data.contract.in_pool ? 'In Pool' : 'Not in Pool' }}
        </span>
      </div>
      @if (data.contract.failed_reason) {
      <div class="info-row">
        <span class="label">Fail Reason:</span>
        <span class="value error-text">{{ data.contract.failed_reason }}</span>
      </div>
      }
      @if (data.contract.current_issue) {
      <div class="info-row">
        <span class="label">Current Issue:</span>
        <span class="value warning-text">
          {{ data.contract.current_issue.type }} — resumes {{ formatDate(data.contract.current_issue.resume_at) }}
        </span>
      </div>
      }
    </div>

    <div class="info-section">
      <h3>Coins</h3>
      <div class="info-row">
        <span class="label">Target:</span>
        <span class="value">{{ formatCoins(data.contract.target_coins) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Fee:</span>
        <span class="value">{{ formatToman(data.contract.fee) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Fee Amount:</span>
        <span class="value">{{ formatToman(data.contract.fee_amount) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Est. Sent:</span>
        <span class="value">{{ formatCoins(data.contract.estimated_sent_coins) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Est. Received:</span>
        <span class="value">{{ formatCoins(data.contract.estimated_received_coins) }}</span>
      </div>
    </div>

    @if (data.contract.cards_summary) {
    <div class="info-section">
      <h3>Cards Summary</h3>
      <div class="info-row">
        <span class="label">Total:</span>
        <span class="value">{{ data.contract.cards_summary.total }}</span>
      </div>
      <div class="info-row">
        <span class="label">Listed:</span>
        <span class="value">{{ data.contract.cards_summary.listed }}</span>
      </div>
      <div class="info-row">
        <span class="label">Sold:</span>
        <span class="value">{{ data.contract.cards_summary.sold }}</span>
      </div>
      <div class="info-row">
        <span class="label">Expired:</span>
        <span class="value">{{ data.contract.cards_summary.expired }}</span>
      </div>
    </div>
    }

    <div class="info-section">
      <h3>Timestamps</h3>
      <div class="info-row">
        <span class="label">Started At:</span>
        <span class="value">{{ formatDate(data.contract.started_at) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Expires At:</span>
        <span class="value">{{ formatDate(data.contract.expire_at) }}</span>
      </div>
      @if (data.contract.stopped_at) {
      <div class="info-row">
        <span class="label">Stopped At:</span>
        <span class="value">{{ formatDate(data.contract.stopped_at) }}</span>
      </div>
      }
      @if (data.contract.quick_sell_started_at) {
      <div class="info-row">
        <span class="label">Quick Selling Since:</span>
        <span class="value">{{ formatDate(data.contract.quick_sell_started_at) }}</span>
      </div>
      }
      <div class="info-row">
        <span class="label">Finished At:</span>
        <span class="value">{{ formatDate(data.contract.finished_at) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Created At:</span>
        <span class="value">{{ formatDate(data.contract.created_at) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Updated At:</span>
        <span class="value">{{ formatDate(data.contract.updated_at) }}</span>
      </div>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>